import { render } from "./PersonalizacaoEdit.vue?vue&type=template&id=c8f08298"
import script from "./PersonalizacaoEdit.vue?vue&type=script&lang=js"
export * from "./PersonalizacaoEdit.vue?vue&type=script&lang=js"
script.render = render

export default script